
export default function numColumn(name, label) {
    return {
        name: name, label: label,
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } })
        }
    }
}